import styled, { css } from "styled-components";

const theme = {
  default: css`
    background: #002244;
    color: #fff;
  `,
  secondary: css`
    background: #e2e8f0;
    color: #002244;
  `,
  destructive: css`
    background: #fecaca;
    color: #f91b1b;
  `,
  destructive2: css`
    background: #991b1b;
    color: #fff;
  `,
};

const size = {
  lg: css`
    font-size: 14px;
    height: 46px;
  `,
  md: css`
    height: 43.14px;
    font-size: 12px;
  `,
  sm: css`
    height: 26px;
    font-size: 12px;
  `,
};

export const ButtonContainer = styled.button`
  font-family: Open Sans;
  font-weight: 700;
  line-height: 25.14px;
  padding: 4px 16px;
  letter-spacing: 0%;
  text-transform: uppercase;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 2px 4px 9px rgba(0, 0, 0, 0); 

  ${(props) => theme[props.theme] ?? theme.default};
  ${(props) => size[props.size] ?? size.md};
  &:disabled {
    opacity: 0.5;
    box-shadow: unset !important; 
    cursor: not-allowed;
  }
  
  &:hover {
   box-shadow: 2px 4px 9px rgba(0, 0, 0, 0.25); 
  }

  &:active {
   box-shadow: 2px 4px 9px rgba(0, 0, 0, 0.45); 
  }

  ${({noShadow}) => noShadow && css`
    box-shadow: unset !important;
  `}
`;
